import React from 'react'
import Page from '../../components/Page'
import RowList from '../../components/Main/RowList'
import DoubleColumnList from '../../components/Main/DoubleColumnList'
import { getAllPress, getWpPresspage } from '../../data/press'

export default function Press (props) {
  const { press: pressPosts } = props.page

  return (
    <React.Fragment>
      <Page
        title={'Press'}
        body={
          'A list of external press articles about The Quell Foundation containing publishing dates, the article headline, and links to those articles'
        }
        slug='/press'
      >
        <main id='content'>
          <div className='container single-page press-release'>
            <RowList singlePage title='Press' />
            <DoubleColumnList press content={pressPosts} />
          </div>
        </main>
      </Page>
    </React.Fragment>
  )
}

export async function getStaticProps ({ preview = false }) {
  const page = {
    pressPage: await getWpPresspage(),
    press: await getAllPress()
  }

  return {
    props: {
      page
    }
  }
}
